export const formatFromEnumToTitleCase = (enumString: string) => {
  return enumString.replace(/_/gi, ' ').replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
